export const ConvertToTimeFormat = (value) => {
  if (!value || value === 0) return "0";

  const hrs = Math.floor(value);
  const mins = Math.round((value - hrs) * 60);

  return `${hrs}:${mins.toString().padStart(2, "0")}`;
};

const firstShiftIN = process.env.REACT_APP_SHIFT_1_IN;
const firstShiftOUT = process.env.REACT_APP_SHIFT_1_OUT;
const secondShiftIN = process.env.REACT_APP_SHIFT_2_IN;
const secondShiftOUT = process.env.REACT_APP_SHIFT_2_OUT;

export const GetCurrentShift = () => {
  const now = new Date();
  const current = now.getHours() * 60 + now.getMinutes();

  const toMin = (t) => {
    if (!t || typeof t !== "string") return 0;
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
  };

  const s1Start = toMin(firstShiftIN);
  const s1End = toMin(firstShiftOUT);
  const s2Start = toMin(secondShiftIN);
  const s2End = toMin(secondShiftOUT);

  if (current >= s1Start && current <= s1End) return "Shift 1";

  if (current >= s2Start || current <= s2End) return "Shift 2";

  return "Unknown";
};

export const FormatKey = (key) => {
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
